import { useState } from "react";
import MLSDisclaimerLogo from "./../../assets/images/NorthstarMLStransparent.png";
import pdf from "./../../assets/Northern.pdf";
import MLSSystemDetails from "./MLSSystemDetails";
import MLSAgreementDetailModal from "./MLSAgreementDetail";

export default function MLSDisclaimer() {
    const [isSystemDetailOpen, setIsSystemDetailOpen] = useState(false);
    const [isAgreementModalOpen, setIsAgreementModalOpen] = useState(false);
    const handleSystemDetailModal = () => {
        setIsSystemDetailOpen(true);
    };
    const handleAgreementModal = () => {
        setIsAgreementModalOpen(true);
    };
    return (
        <div className="tw-bg-white tw-shadow-md tw-rounded-lg tw-p-4 tw-border tw-border-gray-200">
            <MLSAgreementDetailModal onClose={() => setIsAgreementModalOpen(false)} visible={isAgreementModalOpen} pdfUrl={pdf} />
            <MLSSystemDetails onClose={() => setIsSystemDetailOpen(false)} visible={isSystemDetailOpen} />
            <div className="tw-flex tw-items-center tw-mb-2">
                <img src={MLSDisclaimerLogo} alt="Northstar MLS" className="tw-h-12 tw-mr-2" />
                {/* <h2 className="tw-text-lg tw-font-semibold tw-text-blue-700">
                    Northstar <span className="tw-text-gray-600">MLS</span>
                </h2> */}
            </div>
            <p className="tw-text-medium tw-text-gray-700">
                Based on information submitted to the MLS GRID as of <strong>2024-10-08 05:41:19 PDT</strong>. All data is obtained from various
                resources and may not have been verified by broker or MLS GRID. Supplied open house information is subject to change without notice.
                All information should be independently reviewed and verified for accuracy. Properties may or may not be listed by the office/agent
                presenting the information. Some IDX listings have been excluded from this website{" "}
                <span onClick={handleSystemDetailModal} className="tw-text-blue-600 tw-underline">
                    Click here for more information
                </span>
                .
            </p>
            <p className="tw-text-sm tw-text-gray-700 tw-mt-2">
                By searching Northstar MLS listings, you agree to the{" "}
                <span onClick={handleAgreementModal} className="tw-text-blue-600 tw-underline">
                    Northstar MLS End User License Agreement
                </span>
                .
            </p>
        </div>
    );
}
